import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';

@Component({
    selector: 'app-chevron-confirm-popup',
    imports: [CommonModule, DialogModule, TableModule],
    templateUrl: './chevron-confirm-popup.component.html',
    styleUrls: ['./chevron-confirm-popup.component.scss']
})
export class ChevronConfirmPopupComponent {
  @Input() visible: boolean = false;
  @Input() loadingBaseline: boolean = false;
  @Input() preparing: boolean = false;
  @Input() saving: boolean = false;
  @Input() title: string = 'Confirm';
  @Input() message: string = '';
  @Input() lastModifiedBy?: string;
  @Input() lastModifiedAtUtc?: string;
  @Input() diffs: {inputId:number; name:string; oldValue:any; newValue:any;}[] = [];
  @Input() auditTrail: {correlationId:string; user:string; occurredAtUtc:string; inputId:number; uiName:string; oldValue:any; newValue:any;}[] = [];

  @Output() accept = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() visibleChange = new EventEmitter<boolean>();

  onHide(){ this.visibleChange.emit(false); }
  onCancel(){ this.cancel.emit(); this.visibleChange.emit(false); }
  onAccept(){ this.accept.emit(); }
}
